import React, {Component} from 'react';
import PropTypes from 'prop-types';


class Collapsed extends Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			open: false
		}
		this.toggleHandler = this.toggleHandler.bind(this);
	}

	toggleHandler() {
		const newVal = !this.state.open;
		this.setState({open: newVal});
	}

	render() {
		return (
			<div>
				<h3>{this.props.title}</h3>
				{this.state.open === true && this.props.children}
				<div className="collapsed">
					<a onClick={this.toggleHandler} className={this.state.open === true ? "btn done" : "btn start"}>{this.state.open === true ? "Done" : "Start"}</a>
				</div>
				<hr/>
			</div>
		)
	}
}



export default Collapsed;



// WEBPACK FOOTER //
// ./src/components/common/Collapsed.js